// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./Slider.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import {
  SliderRoot,
  SliderTrack,
  SliderProgress,
  SliderThumb,
} from "../_internal_slider";

const styles = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "boolean",
    propName: "secondary",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "boolean",
    propName: "secondary",
    layers: {},
  },
];

const variantPropTypes = [
  {
    type: "boolean",
    propName: "secondary",
  },
];

export const SliderContext = createContext(null);

function Slider(_props) {
  const defaults = useContext(SliderContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <SliderRoot
      {...props}
      key="slider-root"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "slider-root",
        scope: "SJo7zQ8K5D",
        activeVariants: activeVariants,
      }}
    >
      <SliderTrack
        key="slider-track-layer"
        id={"Track_slider-track-layer"}
        className="__visly_reset_7X7HTLRqyD __visly_scope_SJo7zQ8K5D_slider-track-layer"
      >
        <SliderProgress
          key="slider-progress-layer"
          id={"Progress_slider-progress-layer"}
          className="__visly_reset_7X7HTLRqyD __visly_scope_SJo7zQ8K5D_slider-progress-layer"
        />
        <SliderThumb
          key="slider-thumb-layer"
          id={"Thumb_slider-thumb-layer"}
          className="__visly_reset_7X7HTLRqyD __visly_scope_SJo7zQ8K5D_slider-thumb-layer"
        />
      </SliderTrack>
    </SliderRoot>
  );
}

Slider.__variants = [
  {
    name: "secondary",
    type: "variant",
  },
];

export default Slider;
